
import React,{useState,useEffect} from 'react';
import SlideShow from './SlideShow';
import { Modal } from 'react-bootstrap';
import './slideanimation.scss';
const MaterialPreview = (props) => {
    const [data,setData] = useState(props.items[0]);
    const closePreview = () => {
        props.closePreview(false);
        props.setSingleMediaPreviewSrc('')
    }
    useEffect(() => {
        if(props.singleMediaPreviewSrc !== ''){
            setData(props.singleMediaPreviewSrc);
        }
    }, [props.singleMediaPreviewSrc]);

    return (
        <>
            <div>
                <div className="App p-4">
                    <Modal size="lg" centered show={props.show}>
                        <Modal.Header closeButton onClick={closePreview}>
                            <Modal.Title>Preview </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="materialModal">
                            <div>
                                <SlideShow items={data} animation={props.animation}/>
                            </div>
                        </Modal.Body>

                    </Modal>
                </div>
            </div>
        </>
    )
};
export default MaterialPreview;
